const checkMatchWith = () => {
    document.querySelectorAll('.animate-match').forEach((element, idx) => {
        const {top, left, bottom, right} = element.getBoundingClientRect();
        // if(top <= 0 && bottom >= 0) {
        //     console.log('passou')
            // if(!element.classList.contains('animate-icons--loaded')){
            //     element.classList.add('animate-icons--loaded')
            // }
        // }
        const maxHeight = document.documentElement.clientHeight + 200;
        if(top >= 0 && left >= 0 && bottom <= maxHeight && right <= (window.innerWidth || document.documentElement.clientWidth)){
            if(!element.classList.contains('animate-match--loaded')){
                element.classList.add('animate-match--loaded')
            }
        }/*else{
            if(element.classList.contains('animate-match--loaded')){
                element.classList.remove('animate-match--loaded')
            }
        }*/
    });
}

window.addEventListener('scroll', checkMatchWith);